import { render, staticRenderFns } from "./GradeSeoEn.vue?vue&type=template&id=b9f63d4e&"
import script from "./GradeSeoEn.vue?vue&type=script&lang=js&"
export * from "./GradeSeoEn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports